import {PlayersStatisticsTableRowMemberRowApiModel} from "./players-statistics.table.row.member-row.api-model";
import {LineupsMemberDomainModel} from "../../../../lineups-member/lineups-member-domain-model";
import {PlayersStatisticsTableRowDomainModel} from "../players-statistics.table.row.domain-model";

export class PlayersStatisticsTableRowMemberRowDomainModel extends PlayersStatisticsTableRowDomainModel {
  apiModel: PlayersStatisticsTableRowMemberRowApiModel;
  member: LineupsMemberDomainModel;

  constructor(apiModel: PlayersStatisticsTableRowMemberRowApiModel, member: Array<LineupsMemberDomainModel>) {
    super(apiModel);

    this.member = member;
  }

  get groupId(): Number {
    return this.apiModel.groupId;
  }

  get num(): Number {
    return this.apiModel.num;
  }
}
